import React, { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import Link from "@material-ui/core/Link";
import ArrowBackIcon from "@material-ui/icons/ArrowBackRounded";
import { useHistory } from "Hooks/useRouter";
import useStyles from "./styles";

export type Props = {
  to: string;
}

const DPBackArrow: FC<Props> = ({ to }) => {
  const history = useHistory();
  const classes = useStyles();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const locationState = history.location.state as any;
  const canGoBack = locationState && locationState.prevPath;

  return (
    <Link
      color="textPrimary"
      underline="always"
      component={RouterLink}
      className={classes.backLink}
      to={to}
      onClick={(evt: {preventDefault: () => void}) => {
        if (!canGoBack) return;
        evt.preventDefault();
        history.goBack();
      }}
    >
      <ArrowBackIcon className={classes.backLinkIcon} />
    </Link>
  );
};

export default DPBackArrow;
